import { render } from "./Material.vue?vue&type=template&id=4d8bf3a7&scoped=true"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"

import "./Material.vue?vue&type=style&index=0&id=4d8bf3a7&lang=scss&scoped=true"
import "./Material.vue?vue&type=style&index=1&id=4d8bf3a7&lang=scss&scoped=true"

import exportComponent from "F:\\Hongjia\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8bf3a7"]])

export default __exports__